import { Component, OnInit } from '@angular/core';
import { InfoListOcurrenceService } from './info-list-ocurrence.service';
import { MainContainerService } from '../main-container/main-container.service';
import { TipoOcorrenciaEspecial, Util } from '../shared/util.service';
import { ApiConService } from '../shared/api-con.service';
import { PopupConfigService } from '../popup-config/popup-config.service';
import { PopupOcorrenciaService } from '../popup-ocorrencia/popup-ocorrencia.service';
import { JsonReturn } from '../interface/generic-interface';
import { AvaliacaoService } from '../modal-avaliacao/avaliacao.service';

@Component({
  standalone: false,
  selector: 'info-list-ocurrence',
  templateUrl: './info-list-ocurrence.component.html',
  styleUrls: ['./info-list-ocurrence.component.css']
})
export class InfoListOcurrenceComponent implements OnInit {

  listOcurrence: any;
  totalOcorrencias: number;
  listStatusFinalizacao: any[] = [];
  tipoOcorrenciaEspecial = TipoOcorrenciaEspecial;
  configNomeClienteExibicao = ConfiguracaoInfoCliente.RazaoSocial;
  enumConfiguracaoInfoCliente = ConfiguracaoInfoCliente;
  constructor(
    private infoListOcurrenceService: InfoListOcurrenceService,
    public mainContainerService: MainContainerService,
    public util: Util,
    private conService: ApiConService,
    private popupConfigService: PopupConfigService,
    private popupOcorrencia: PopupOcorrenciaService,
    public avaliacaoService: AvaliacaoService
  ) { }

  ngOnInit() {
  }

  scroolToBottom() {
    setTimeout(() => {
      let chatArea = document.getElementById("chat-conteudo");
      chatArea.scrollTop = chatArea.scrollHeight;      
    }, 1);
  }

  async visualizarOcorrenciaAlerta(){
    await this.visualizarOcorrencia(this.popupConfigService.objOcorrencia)
  }

  async visualizarOcorrencia(objOcorrencia) {

    this.configNomeClienteExibicao =  objOcorrencia.configNomeClienteExibicao? objOcorrencia.configNomeClienteExibicao: ConfiguracaoInfoCliente.RazaoSocial
    this.mainContainerService.listaPedidosNotas = [];
    this.mainContainerService.loadingListaPedidosNotas = true
    let msgInicialData = [];
    let dataPrimeiraMsg = '';
    this.popupConfigService.objOcorrencia = objOcorrencia;
    this.popupConfigService.chaveAcesso = objOcorrencia.chaveAcesso;
    this.popupConfigService.mostraBtnCompartilhar = this.compararVersao('7.0.11', objOcorrencia.VersaoRetaguarda)
    this.mainContainerService.atualizacaoOcorrencia = false;
    this.mainContainerService.ocorrenciaSelecionado = [];
    this.mainContainerService.listaOcorrenciaLogs = [];
    this.mainContainerService.ocorrenciaSelecionado.push(objOcorrencia);
    this.mainContainerService.ocorrenciaSelecionado[0].dadosJson = JSON.parse(this.mainContainerService.ocorrenciaSelecionado[0].Json);
    this.popupOcorrencia.loadingMsg = true;
    const responseMsg: JsonReturn = await this.conService.patch('DCocorrenciaMensagem/' +
    this.mainContainerService.ocorrenciaSelecionado[0].CodigoOcorrencia);
    this.mainContainerService.listaOcorrenciaLogs = await this.popupConfigService.getListaOcorrenciaLog( this.mainContainerService.ocorrenciaSelecionado[0].IdOcorrencia)
    await this.consultaPedidoNfPorCodigoOcorrencia(objOcorrencia.CodigoCliente)
    this.popupOcorrencia.loadingMsg = false;
    this.mainContainerService.listaOcorrenciasMsg = responseMsg.response;
    this.mainContainerService.ocorrenciaSelecionado[0].configNomeClienteExibicao = this.configNomeClienteExibicao;

    //Trata Custo Extra
    if(this.mainContainerService?.ocorrenciaSelecionado[0]?.TipoEspecial == this.tipoOcorrenciaEspecial.CUSTO_EXTRA){
      dataPrimeiraMsg = this.mainContainerService.listaOcorrenciasMsg[0].Data;
      msgInicialData = this.mainContainerService.listaOcorrenciasMsg.filter((element) => element.Data == dataPrimeiraMsg);
      this.mainContainerService.ocorrenciaSelecionado[0].imagensCustoExtra = []
      msgInicialData.forEach((dadosMsg) =>{
        let isBase64 = this.isBase64(dadosMsg?.Mensagem)
        if(isBase64){
          this.mainContainerService.ocorrenciaSelecionado[0].imagensCustoExtra.push(dadosMsg?.Mensagem) 
        }else{
          this.mainContainerService.ocorrenciaSelecionado[0].msgCustoExtra = dadosMsg?.Mensagem;
        }
      })
    }

    //Trata Horario  Recebimento
    if(this.mainContainerService?.ocorrenciaSelecionado[0]?.TipoEspecial == this.tipoOcorrenciaEspecial.HORARIO_RECEBIMENTO){
      dataPrimeiraMsg = this.mainContainerService.listaOcorrenciasMsg[0].Data;
      msgInicialData = this.mainContainerService.listaOcorrenciasMsg.filter((element) => element.Data == dataPrimeiraMsg);
      msgInicialData.forEach((dadosMsg) =>{
        this.mainContainerService.ocorrenciaSelecionado[0].msgHorarioRecebimento = dadosMsg?.Mensagem;
      })
    }

    this.mainContainerService.listaOcorrenciasMsg = this.mainContainerService.listaOcorrenciasMsg.map((element) => {
        element.Mensagem = element.Mensagem.replaceAll('\\n', '<br>' )
         return element
    }) 
    for (let x = 0; x < this.mainContainerService.listaOcorrencias.length; x++)
    {
      if (String(this.mainContainerService.listaOcorrencias[x].CodigoOcorrencia) === String(this.mainContainerService.ocorrenciaSelecionado[0].CodigoOcorrencia)) 
      {        
        this.mainContainerService.ocorrenciaSelecionado[0].ocorrenciaMsg = responseMsg.response.splice(msgInicialData.length);
      }
      if (this.mainContainerService.listaOcorrencias[x].InfoRota) 
      {
        this.mainContainerService.listaOcorrencias[x].InfoRota = JSON.parse(this.mainContainerService.listaOcorrencias[x].InfoRota);
      }
    }
    const response = await this.popupConfigService.getListaStatusFinalizacao();
    this.scroolToBottom();
   
    //trata mensagem que contem arquivo pdf/xml
    this.mainContainerService.ocorrenciaSelecionado[0].ocorrenciaMsg.forEach(dadosMsg => {      
      if(dadosMsg.Storage == 1 ) {
        let dataExpiracao = new Date(dadosMsg.Data.replace('Z', ''))
        dataExpiracao.setHours(dataExpiracao.getHours() + 48);
        dadosMsg.Mensagem = JSON.parse(dadosMsg.Mensagem)
        dadosMsg.expirou = this.util.expirouTempo(48 , dadosMsg.Data);       
        dadosMsg.dataExpiracao = dataExpiracao;
        dadosMsg.Mensagem.nomeArquivo = this.util.trataNameArquivo(dadosMsg.Mensagem.nomeArquivo, 20)
      } 
    });
    document.getElementById('btnIniciaConsultaMsg')?.click();
  }

  async consultaPedidoNfPorCodigoOcorrencia(codigoCliente: number | null) {  
   if(codigoCliente){
    this.mainContainerService.listaPedidosNotas = await this.popupConfigService.getListaPedidoNotaOcorrencia( this.mainContainerService.ocorrenciaSelecionado[0].CodigoOcorrencia, codigoCliente);
    this.mainContainerService.pedidosOcorrenciaAtual = this.formatarLista('NumeroPedido')
    this.mainContainerService.notasOcorrenciaAtual = this.formatarLista('Nf')
   } 
   this.mainContainerService.loadingListaPedidosNotas = false
  }

  isBase64(str: any) {
    var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    var isbase64 = base64regex.test(str) && str.length > 200 && !str.includes(" ") ;    
    return isbase64;    
  }

  compararVersao(versaoLiberada, versaoRetaguarda){
    if(versaoRetaguarda == null) return false;
    const verRetarguarda = versaoRetaguarda.split('.').map(Number);
    const verLiberada = versaoLiberada.split('.').map(Number);
    const maiorOuIgual = 
    verRetarguarda[0] > verLiberada[0] ? true :
    verRetarguarda[0] < verLiberada[0] ? false :
    verRetarguarda[1] > verLiberada[1] ? true :
    verRetarguarda[1] < verLiberada[1] ? false :
    verRetarguarda[2] >= verLiberada[2];
    return maiorOuIgual;
  };

  async abreOcRoteiroBuscaRadar(){
    const ocorrenciasRoteiro = [
      ...this.mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.novo,
      ...this.mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.analise,
      ...this.mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.finalizado
    ]
    const ocBusca = ocorrenciasRoteiro.find((oc) => oc.CodigoOcorrencia == this.popupOcorrencia.ocRoteiroBusca.codigoOcorrencia)

    await this.visualizarOcorrencia(ocBusca);
  }

  fecharModal() {
    this.avaliacaoService.exibirModalAvaliacao = false;
  }

  private formatarLista(campo) {
    if(this.mainContainerService.listaPedidosNotas.length){
      const valores = this.mainContainerService.listaPedidosNotas
        .map(item => item[campo])
        .filter(v => v !== undefined && v !== null);

      if (valores.length === 0) return '';
      if (valores.length === 1) return valores[0].toString();
      if (valores.length === 2) return `${valores[0]} e ${valores[1]}`;

      return `${valores.slice(0, -1).join(', ')} e ${valores[valores.length - 1]}`;
    }
  }
}

export enum ConfiguracaoInfoCliente {
  RazaoSocial = '1',
  NomeFantasia = '2'
}

